import { base, BASE } from "./libs/sdk.base";

window.KKMHSDk=(function(){
    // KKMHSDk hybrid协议外露类
    class KKMHSDk extends BASE{
        constructor() { 
            const href = window.location.href;
            const env = /kuaikanmanhua.com/.test(href) ? "pro":"dev";
            super(env);
        }
  
        static UA({ success=() => {}, error=() => {} }){

            if(!base.isFunction(error)){error=() => {}}
            if(!base.isFunction(success)){
                error({code:400,data:{},message:"Please check the success parameters."});
                return false;
            }
            let userAgent = navigator.userAgent.toLowerCase();
            let is_iphone_qqnative = (/(iphone|ipod|ipad)/i.test(userAgent) && / QQ/i.test(navigator.userAgent));
            let is_android_qqnative = (/android/.test(userAgent) && /\sQQ/i.test(navigator.userAgent) && /QQ/i.test((navigator.userAgent).split("MQQBrowser")));
      
            let vReg=/\/\d{4,6}\(/ig;
            let version = 0;
      
            //如果是app 环境下获取版本号
            if(/kuaikan\//.test(userAgent)){  
                let vList = userAgent.match(vReg); //version
                if( vList && vList[0]){
                    version = vList[0]+"";
                    version = version.replace(/\//ig,"").replace(/\(/ig,"");
                }
            }
      
            let data = {
                code:200,
                data:{
                    iphone: /(iphone|ipod|ipad)/i.test(userAgent),
                    android: /android/.test(userAgent),
                    kkmh: /kuaikan\//.test(userAgent),
                    version, //app 版本号
                    weixin: /micromessenger/.test(userAgent),
                    weibo: /weibo/.test(userAgent),
                    qqnative: (is_android_qqnative || is_iphone_qqnative),
                    qq: /qq/.test(userAgent),
                    alipay: /alipay/.test(userAgent),
                    meipai: /com.meitu.mtmv/.test(userAgent),
                    pc: !/(iphone|ipod|ipad|android|webos|blackberry)/.test(userAgent),
                },
                message:"ok"
            };
            success(data);
        }
        
        //设置显示页面,接收消失的回调函数,建议一个页面设置一次  Android: 523000  IOS: 523000
        appOnShow(callback){
            if(!base.isFunction(callback)){callback = () => {}}
            base.subscribeListenerOnViewBack(callback);
        }
          
        //设置接收网卡信息,接收消失的回调函数, 建议一个页面设置一次       注:接收场景：网络切换情况 + subscribeListenerOnViewBack业务情况（指:webview之间跳转，native跳转，第三方app之间跳转等情况）
        appRecivefreecardinfo(callback){
            if(!base.isFunction(callback)){callback = () => {}}
            base.recivefreecardinfo(callback);
        }
  
        /** 
           * * appViewStatus  通知webview显示与否
           * Android: 43000  Os: 43000
           * * 参数对象集合:
           * @success 成功后的回调函数
           * @error   失败后的回调
           * 
           * 
           * {
                data: {
                  isVisible: 1 // （1表示，页面可见；0表示，页面不可见；2表示，退出webview）
                },
                code: 200,
                message: "success"
            }
          * **/
        appViewStatus({ success=() => {}, error=() => {} }){
            if(!base.isFunction(error)){error=() => {}}
            if(!base.isFunction(success)){
                error({code:400,data:{},message:"Please check the success parameters."});
                return false;
            }
  
            base.hybrid({
                schema:"kkhybrid",
                tagname:"registViewStatus",
                is_del_nativecallback:false,// 不删除回调函数
                success,
                error
            });
  
        }
          
        //UA相关 S
  
        /** 
           * * getAppUA 获取当前用户的运行环境
           * Android & iOs 支持
           * 参数对象集合:
           * {
           *    @success 成功后的回调函数
           *    @error   失败后的回调
           * }
           *
           * 成功:
           * {
           *  code:200,
           *  data:{
           *      iphone 是否是 ios 系统
           *      android 是否是 android 系统
           *      kkmh  是否是 快看app内运行
           *  },
           *  message:'ok'
           * }
           * 失败:
           * {code:400,data:{},message:错误信息}
           * **/
        getAppUA({ success=() => {}, error=() => {} }){
            KKMHSDk.UA({success,error});
        }
        //UA相关 E
  
  
        //登录相关S
        /** 
           * * appLogin 调用登录界面
           * Android: 40100  Os: 43000
           * 参数对象集合:
           * {
           *    @success 成功后的回调函数
           *    @error   失败后的回调
           * }
           * 
           * 返回:无
           * 
           * 成功回调接收的数据
           * {
           *     code: 200,
           *     data: {
           *       "status": 1, "0":用户未登录 ; "1":用户已登录
           *     },
           *     message: "ok"
           * }
           *异常接收数据:{code:400,data:{},message:错误信息}
          * 
          * **/
        appLogin({ success=() => {}, error=() => {} }){
            if(!base.isFunction(error)){error=() => {}}
            if(!base.isFunction(success)){
                error({code:400,data:{},message:"Please check the success parameters."});
            }
            //let _base = base;
            //先退出登录 
            base.hybrid({
                schema:"kkhybrid",
                tagname:"logout",
                is_del_nativecallback:false,// 删除回调函数
                success(){
                    base.hybrid({
                        schema:"kkhybrid",
                        tagname:"login_win",
                        success:success,
                        error
                    });
                },
                error
            });
        }
          
        /** 
           *  * appLogout 登出当前账号
           *  Android: 40100  Os: 43000
           * * 参数对象集合:
           * {
           *    @success 成功后的回调函数
           *    @error   失败后的回调
           * }
           * 
           * 返回:无
           * 
           * 成功回调接收的数据 同appLogin
           * **/
        appLogout({ success=() => {}, error=() => {} }){
            if(!base.isFunction(error)){error=() => {}}
            if(!base.isFunction(success)){
                error({code:400,data:{},message:"Please check the success parameters."});
            }
            //退出登录
            base.hybrid({
                schema:"kkhybrid",
                tagname:"logout",
                is_del_nativecallback:false,// 删除回调函数
                success,
                error
            });
        }
  
        /** 
           * * getLoginResult 获取登录信息
           * Android: 40100   IOs: 43000
           * * 参数对象集合:
           * {
           *    @success 成功后的回调函数
           *    @error   失败后的回调
           * }
           * 
           * 
           * 
           {
              "code": 0,
              "data": {
                "status": 1,
                "session": "uid=390921;session=4c607ce1-7b6a-4c95-8aa7-3763b069a2f2;Expires=Wed, 19-Jul-2017 07:33:39 GMT;Domain=.kuaikanmanhua.com;Path=/",
                "nickname":"nihao"，
                "uid":"390921"，
                "vip_type": 1
              },
              "message": "ok"
          }
          status: "0":未登录状态 ; "1":登录成功
          session: "":未登录状态;  "session=6afa53ee-66c9-489d-a55d-4b4a9b8a8ff7":登录成功
          nickname: "":未登录状态;  "nihao":登录成功
          uid: "":未登录状态；"390921":登录成功
          vip_type  大于0表示是会员，0表示非会员
          remained_time ：会员剩余时间，单位为ms，负数时表示已过期的时间
          memberIdentity： 会员角色
          avatar_url ：头像地址
          * **/
        getLoginResult({success=() => {}, error=() => {}}={}){
            if(!base.isFunction(error)){error=() => {}}
            if(!base.isFunction(success)){
                error({code:400,data:{},message:"Please check the success parameters."});
                return false;
            }
            //获取登录信息
            base.hybrid({
                schema:"kkhybrid",
                tagname:"login_result",
                is_del_nativecallback:false,// 删除回调函数
                success,
                error
            });
        }
        //登录相关E
  
  
        //控制webview S
        /** 
           * * appClosePage 关闭页面  调用 安卓调用:kkaction://finish  ios:kkhybrid://finish
           * Android: 43000  Os: 43000
           * *注* 无回调 无参数
           * 
           * 返回:无
           * **/ 
        appClosePage({success=() => {}, error=() => {}}={}){
            let schema="kkhybrid";
            //let _base = base;
            KKMHSDk.UA({
                success(res){
                    let {code ,data , message} = res;
                    data = data ? data :{};
                    if(data.android){
                        schema="kkaction";
                    }
                    //关闭页面
                    base.hybrid({
                        schema,
                        tagname:"finish",
                        is_del_nativecallback:false,// 删除回调函数
                        success,
                        error
                    });
                }
            });
        }
  
        /** 
           * * appHeader   顶部、底部栏隐藏和显示
           * Android: 43000   IOs: 43000
           * * 参数对象集合:
           * @success 成功后的回调函数  类型:fn    
           * @error   失败后的回调     类型:fn
           * @full    是否全屏         类型:boolean  默认:true   true->全屏显示 false->取消全屏  
           * @type    显示类竖屏|横屏   类型:boolean  默认:true   true->竖屏 false->横屏
           * 
           * success 回调接收参数
           * {
           *   data: {
           *     // 执行后的当前状态 show or hide
           *     fullScreen: 'show'
           *   },
           *   code: 200,
           *   message: "success"
           * }  
           * **/
        appHeader({success=() => {}, error=() => {} , full = true , type = true}={}){
            if(!base.isFunction(error)){error=() => {}}
            if(!base.isFunction(success)){
                error({code:400,data:{},message:"Please check the success parameters."});
            }
  
            if( !base.isBoolean(full) ){
                error({code:400,data:{},message:"full: Must be Boolean type data."});
                return false;
            }
            if( !base.isBoolean(type) ){
                error({code:400,data:{},message:"type: Must be Boolean type data."});
                return false;
            }
            //顶部、底部栏隐藏和显示
            base.hybrid({
                schema:"kkhybrid",
                tagname:"header",
                is_del_nativecallback:false,// 不删除回调函数
                param:{
                    config: "screen",
                    display: type ? 1 : 2, // 1：竖屏，2：横屏
                    fullScreen: full ? "show" :"hide", // 'show' 全屏显示， 值为 'hide' 取消全屏
                    data: {},
                },
                success,
                error
            });
        }
  
        /** 
           * * appSetNavRightButtons Hybrid头部多按钮定制协议  注:setNavRightViews 由于ios为实现所以暂不封装
           * Android: 43000   IOs: 43000
           * * 参数集合
           * @btnImgUrl 按钮图片地址      类型:字符串      默认值:快看ico图标                         注:必须有效的图片地址
           * @forward  点击按钮跳转链接    类型:字符串     默认值:快看m站官网                          注:必须有效链接地址
           * @redShow  是否显示红点       类型:Boolean   默认值:false  true->显示  false->不显示     注:必须是Boolean类型
           * @redShowType 是否一直存在    类型:Boolean   默认值:false  true->显示  false->不显示     注:必须是Boolean类型 
           * @show     按钮是否显示       类型:Boolean   默认值:true  true->显示  false->不显示     注:必须是Boolean类型
           * @index    按钮索引          类型:number    默认值:0 
           * @location  按钮位置         类型:string    默认值:'right'                             注:必须是left|right    
           * @success 成功后的回调函数    类型:fn       
           * @error   失败后的回调       类型:fn   
           *  
           * 
           * success 接收参数
           * {
           *    code:200,
           *    data:{},
           *    message: "success"
           * }
           * **/ 
        appSetNavRightButtons({
            btnImgUrl="https://static3w.kuaikanmanhua.com/static/img/favicon.ico", //按钮图片地址
            forward="https://m.kuaikanmanhua.com/",//点击消息提示跳转链接
            redShow=false,//是否显示红点
            redShowType=false,//0(false)点击消失 1(true)一直存在
            show=true , //按钮是否显示
            location="right", //按钮位置  left、right 
            index = 0,//按钮索引
            success=() => {}, 
            error=() => {},
        }={}){
            if(!base.isFunction(error)){error=() => {}}
            if(!base.isFunction(success)){
                error({code:400,data:{},message:"Please check the success parameters."});
            }
  
            if( !base.isUrl(btnImgUrl) ){
                //不是有效的url地址的情况下
                error({code:400,data:{},message:"btnImgUrl:must be a valid picture address."});
                return false;
            }
  
            if( !base.isBoolean(redShow) ){
                error({code:400,data:{},message:"redShow: Must be Boolean type data."});
                return false;
            }
  
            if( !base.isBoolean(redShowType) ){
                error({code:400,data:{},message:"redShowType: Must be Boolean type data."});
                return false;
            }
                
            if( !base.isBoolean(show) ){
                error({code:400,data:{},message:"show: Must be Boolean type data."});
                return false;
            }
  
  
            if( !base.isUrl(forward) ){
                //不是有效的url地址的情况下
                error({code:400,data:{},message:"forward:must be a valid link."});
                return false;
            }
                
            if( !base.isNumber(index)  ){
                error({code:400,data:{},message:"index:must be a number."});
                return false;
            }
                
            //left、right 
            if(location!="left" && location!="right"){
                error({code:400,data:{},message:"location:It can only be left and right."});
                return false;
            }
  
  
            let param ={
                buttons:[{
                    img_url:btnImgUrl ,//按钮图片地址
                    red_show:redShow,//是否显示红点
                    red_show_type:redShowType? 1 : 0,//0点击消失 1一直存在
                    forward, //跳转地址
                    show, //按钮是否显示
                    location, //按钮位置  left、right 
                    index //按钮索引
                }]
            };
  
            //Hybrid头部多按钮定制协议
            base.hybrid({
                schema:"kkhybrid",
                tagname:"setNavRightButtons",
                is_del_nativecallback:false,// 不删除回调函数
                param,
                success, 
                error,
            });
                
  
        }
          
        /** 
           * * appSetTitle  刷新标题  ios:协议修改  And:动态修改DOM title标签(兼容处理)
           * * Android: 43000   IOs: 516000
           * * 参数集合  
           * @title   标题字符串(支持数字)     类型:str  默认:''   
           * @success 成功后的回调函数
           * @error   失败后的回调
           * 
           * success返回值
           * {
           *    code:200,
           *    data:{},
           *    message:"ok"
           * }
           * **/
        appSetTitle({title="",success=() => {}, error=() => {}}={}){
            if(!base.isFunction(error)){error=() => {}}
            if(!base.isFunction(success)){
                error({code:400,data:{},message:"Please check the success parameters."});
            }
            if(base.isString(title)||base.isBoolean(title)){
                //let _base = base;
                // KKMHSDk 
                KKMHSDk.UA({
                    success(res){
                        let {code ,data , message} = res;
                        data = data ? data :{};
                        if(data.android){
                            let ele = document.querySelector("title");
                            if(ele){
                                ele.innerHTML=title;
                                success({code:200,data:{},message:"ok"});
                            }else{  
                                error({code:400,data:{},message:"DOM Title element could not be found."});
                            }
                            return false;
                        }
  
                        base.hybrid({
                            schema:"kkhybrid",
                            tagname:"settitle",
                            is_del_nativecallback:false,// 删除回调函数
                            success,
                            error,
                            param:{
                                title 
                            }
                        });
                    }
                });
            }else{
                error({code:400,data:{},message:"title: must be a numeric latter string"});
                return false;
            }
        }
        //控制webview E
  
  
        //获取app信息 S
        /** 
           * * getAppVersion 获取本地应用版本信息   (kkaction)
           * * Android: 25000   IOs: 25000
           * * 参数集合  
           * @success 成功后的回调函数
           * @error   失败后的回调
           * 
           * success 接收参数
           * {code:200 , data:{} , message:''}
           * **/
        getAppVersion({success=() => {}, error=() => {}}={}){
            base.hybrid({
                schema:"kkaction",
                tagname:"getAppVersion",
                success,
                error
            });
        }
          
        /** 
           * * getSysDeviceInfo  客户端信息 kkaction
           * Android: 32000  IOS:32000
           * * 参数集合
           * @success 成功后的回调函数
           * @error   失败后的回调
           * 
           * success 接收参数
           * 产看地址:http://wiki.quickcan.com/pages/viewpage.action?pageId=43387251
           * **/ 
        getSysDeviceInfo({success=() => {}, error=() => {}}={}){
            base.hybrid({
                schema:"kkaction",
                tagname:"getSysDeviceInfo",
                is_del_nativecallback:false,// 删除回调函数
                success,
                error
            });
        }
          
        /** 
           * * getSysData sys(获取设备信息)hybrid
           * * Android: 43000   IOs: 536000
           * * 参数集合
           * @tpey 获取信息的类型       类型:string      默认:''     注:仅支持 network -> 获取网络状态 | system -> 获取系统信息
           * @success 成功后的回调函数
           * @error   失败后的回调
           *  
           * success 接收参数
           * 产看地址:http://wiki.quickcan.com/pages/viewpage.action?pageId=43387143
           * **/
        getSysData({
            type="",
            success=() => {}, 
            error=() => {}
        }={}){
            if(!base.isFunction(error)){error=() => {}}
            if(!base.isFunction(success)){
                error({code:400,data:{},message:"Please check the success parameters."});
            }
            type = type.replace(/(^ +| +$)/g,"");
            if(type=="network"||type=="system"){
                base.hybrid({
                    schema:"kkhybrid",
                    tagname:"sys",
                    is_del_nativecallback:false,// 删除回调函数
                    param:{
                        info:type
                    },
                    success,
                    error
                });
            }else{
                error({code:400,data:{},message:"type: Support only network and system."});
            }
        }
        //获取app信息 E
  
          
        // 跳转类 S
        /** 
            * * openAppTopic   Native - 跳转漫画专题页 
            * * Android : 510000   IOS : 510000
            * 参数对象集合:
            * {
            *    @success 成功后的回调函数
            *    @error   失败后的回调
            *    @id 漫画专题Id  必填项  默认值:无  类型:number 
            * }
            * 返回:无
            * 
            * 成功:
            * {
            *  code:200,
            *  data:{},
            *  message:成功信息
            * }
            * 失败:
            * {code:100400|400|100490|1002005,data:{},message:错误信息}
            * **/
        openAppTopic({ id=0, success=() => {}, error=() => {} }){
            //window.location.href = 'kkaction://loadTopicDetail?id=' + topicId;
            if(!base.isFunction(error)){error=() => {}}
            let options = {
                schema:"kkaction",
                tagname:"loadTopicDetail?id="+ id,
                is_del_nativecallback:false,// 删除回调函数
                success,
                error,
            };
            if( base.isString(id)||base.isNumber(id) ){
                base.hybrid(options);
            }else{
                let data = { code:400 ,message:"openAppTopic: Please pass the cartoon theme ID" };
                error( base.returnData(data) );
            }
        }
  
        /** 
            * * openAppComic   Native - 跳转漫画章节页
            * * Android : 510000   IOS : 510000
            * 参数对象集合:
            * {
            *    @success 成功后的回调函数
            *    @error   失败后的回调
            *    @id 漫画章节Id  必填项  默认值:无  类型:number
            * }
            * 返回:无
            * 
            * 成功|异常回调 接收数据同 openAppTopic
            * **/
        openAppComic({ id=0, success=() => {}, error=() => {} }){
            if(!base.isFunction(error)){error=() => {}}
            let options = {
                schema:"kkaction",
                tagname:`loadComicDetail?id=${id}`,
                is_del_nativecallback:false,// 删除回调函数
                success,
                error
            };
  
            if( base.isString(id) || base.isNumber(id) ){
                base.hybrid(options);
            }else{
                let data = { code:400 ,message:"openAppComic: Please pass the cartoon chapter ID." };
                error( base.returnData(data) );
            }
        }
  
        /** 
            * * openWebview   新开webview页面 
            * * Android : 510000 IOS : 510000
            * 参数对象集合:
            * {
            *    @success 成功后的回调函数
            *    @error   失败后的回调
            *    @url 新开webview url 地址
            * }
            * 返回:无
            * 
            * 成功|异常回调 接收数据同 openH5Topic
            * **/
        openWebview({ url="", success=() => {}, error=() => {} }){
            if(!base.isFunction(error)){error=() => {}}
  
            let options = {
                schema:"kkhybrid",
                tagname:"forward",
                is_del_nativecallback:false,// 删除回调函数
                success,
                error,
                param:{
                    topage: url , // H5 新开webview跳转 
                    totype: "h5", //漫画章节详情页 0: default , 1: 内容
                    todata: {
                        progress_bar : 1, //默认为 0; 值 1 时,显示头部进度条; 值 0 时,不显示进度条;
                    } 
                }
            };
  
            if(url){
                base.hybrid(options);
            }else{
                let data = { code:400 ,message:"openWebview: Pass the jump URL." };
                error( base.returnData(data) );
            }
        }
          
        /** 
            * * openNavAction 客户端通用跳转  注:ios 部分 页面打不开
            * * Android : 512100   IOS : 512100
            * * 参数集合
            * @success 成功后的回调函数
            * @error   失败后的回调
            * @actionTarget 跳转所需的参数，需要保证和现在客户端的一致    类型:object    必填  注:[url](http://wiki.quickcan.com/pages/viewpage.action?pageId=16265340)   
            * 
            * success 无接收参数
            * **/
        openNavAction({
            actionTarget={},
            success=() => {}, 
            error=() => {}
        }={}){
            if(!base.isFunction(error)){error=() => {}}
            if(!base.isFunction(success)){success=() => {}}
            if(!base.isObject(actionTarget)){
                error({code:400,data:{},message:"actionTarget: must be object datas."});
                return false;
            }
              
            base.hybrid({
                schema:"kkhybrid",
                tagname:"navAction",
                is_del_nativecallback:false,// 删除回调函数
                param:{
                    actionTarget
                },
                success,
                error
            });
  
              
        }
        // 跳转类 S
  
  
        // 调出模块 S
        /** 
            * * openShare 分享 - 分享到微博、qq空间、微信朋友圈、微信好友
            * * Android : 510000   IOS : 510000
            * 参数对象集合配置
            * {
            *   @title :  分享标题              必填项        类型:String        默认值:'' 
            *   @desc: 分享描述                 必填选        类型:String        默认值:'' 
            *   @shareImageUrl : 分享的图片地址  选填项        类型:String        默认值:'' 
            *   @iconUrl :  icon图标地址        选填项        类型:String        默认值:快看icon常用图标链接 
            *   @link  :  分享后点击跳转链接地址   选填项        类型:String        默认值:快看m站官网
            *   @type : 分享类型                选填项        类型:String        默认值:0  //0 分享为网页 1 分享为图片
            *   @success 成功后的回调函数
            *   @error   失败后的回调
            * }
            * 
            * 返回:无
            * 
            * 成功接收数据:
            *   {
            *     data: {
            *        type: type为before表示分享窗口被调起的行为，type为after表示分享结果行为
            *        link: 被分享的链接
            *        result: 操作结果，若type=before，result=1表示分享窗口调起成功，result=0表示分享窗口调起失败；如type=after，result=1表示分享成功，result=0表示分享失败, 2表示分享被取消；
            *        platform: Wechat，微信；WechatMoments，微信朋友圈；SinaWeibo，新浪微博；QZone，QQ朋友圈；QQ
            *     },
            *     code: 200,  0表示成功  1表示失败
            *     message: "success" 
            *   }
            * 
            *   异常接收数据:{code:100400|400|100490|1002005,data:{},message:错误信息}
            * 
            * **/
        openShare({ 
            title="", 
            desc="", 
            shareImageUrl="", 
            iconUrl="",  
            link="https://m.kuaikanmanhua.com/", 
            type=0, 
            sharetype={},
            success=() => {}, 
            error=() => {}
        }={}){
            const param = {
                data: {
                    share: {
                        shareImageUrl,
                        shareType :{
                            "qq": sharetype.qq ? sharetype.qq : type, //0为网页 1为图片
                            "moments": sharetype.moments ? sharetype.moments : type, //0为网页 1为图片
                            "weibo": sharetype.weibo ? sharetype.weibo : type, //0为网页 1为图片
                            "qqZone": sharetype.qqzone ? sharetype.qqzone : type, //0为网页 1为图片
                            "weChat": sharetype.wechat ? sharetype.wechat : type, //0为网页 1为图片
                        },
                        title,
                        desc,
                        imgUrl  : iconUrl ? iconUrl : "https://f12stag.kkmh.com/label/170907/mQRSkZKmF.jpg", //icon地址
                        link,
                    },
                    shareImageUrl,
                    shareType :{
                        "qq": sharetype.qq ? sharetype.qq : type, //0为网页 1为图片
                        "moments": sharetype.moments ? sharetype.moments : type, //0为网页 1为图片
                        "weibo": sharetype.weibo ? sharetype.weibo : type, //0为网页 1为图片
                        "qqZone": sharetype.qqzone ? sharetype.qqzone : type, //0为网页 1为图片
                        "weChat": sharetype.wechat ? sharetype.wechat : type, //0为网页 1为图片
                    },
                    title,
                    desc,
                    imgUrl  : iconUrl ? iconUrl : "https://f12stag.kkmh.com/label/170907/mQRSkZKmF.jpg", //icon地址
                    link,
                }
            };
            if(!base.isFunction(error)){error=() => {}}
            let options = {
                schema: "kkhybrid",
                tagname: "share",
                is_del_nativecallback:false,// 不删除回调函数
                success,
                error,
                param
            };
              
            if(title != "" && desc != ""){
                base.hybrid(options);
            }else{
                let str="";
                if(title=="" && desc==""){
                    str="Please pass a description of the shared title.";
                } else if(title==""){
                    str="Please pass the shared title.";
                }else if(desc==""){
                    str = "Please pass on the shared description.";
                }else{
                    str = "Please check the parameters.";  
                }
  
                let data = { code:400 ,message:str };
                error( base.returnData(data) );
            }
  
        }
          
        /** 
            * * openAlbum 打开相册 [kkhybrid]
            * * Android : 514000 IOS : 不支持
            * * 参数集合
            * @key 网页端识别key            类型:string      默认:''  
            * @type 允许选取的图片格式       类型:Array       默认:['png','jpg','jpeg','webp']  
            * @success 成功后的回调函数
            * @error   失败后的回调
            * 
            * success 接收参数
            * http://wiki.quickcan.com/pages/viewpage.action?pageId=43387187
            * **/
        openAlbum({
            key="",
            type=["png","jpg","jpeg","webp"],
            success=() => {}, 
            error=() => {}
        }={}){
            if(!base.isFunction(error)){error=() => {}} 
            if( !base.isString(key) ){
                error({code:400,data:{},message:"key: must be string type data."});
                return false;
            }
            if( !base.isArray(type) ){
                error({code:400,data:{},message:"type: must be array type data."});
                return false;
            }
            base.hybrid({
                schema:"kkhybrid",
                tagname:"album",
                is_del_nativecallback:false,// 删除回调函数
                param:{
                    key,
                    type
                },
                success,
                error
            });
        }
  
        /** 
            * * openCamera 打开相机  [kkhybrid]
            * * Android : 514000 IOS : 不支持
            * @key 网页端识别key            类型:string      默认:'' 
            * @success 成功后的回调函数
            * @error   失败后的回调
            * 
            * success 接收参数
            * http://wiki.quickcan.com/pages/viewpage.action?pageId=16254595
            * **/
        openCamera({
            key="",
            success=() => {}, 
            error=() => {}
        }={}){
            if(!base.isFunction(error)){error=() => {}} 
            if( !base.isString(key) ){
                error({code:400,data:{},message:"key: must be string type data."});
                return false;
            }
  
            base.hybrid({
                schema:"kkhybrid",
                tagname:"camera",
                is_del_nativecallback:false,// 删除回调函数
                param:{
                    key
                },
                success,
                error
            });
        }
        //调出模块 E
    }

    return new KKMHSDk();
})();

const kkmhSDk = window.KKMHSDk;

const {
    getAppUA,//获取当前用户的运行环境
    //通知
    appOnShow,//设置显示页面
    appRecivefreecardinfo,//设置接收网卡信息
    appViewStatus,//通知webview显示与否
    //控制webView
    appClosePage,//关闭页面
    appHeader,//顶部、底部栏隐藏和显示 
    appSetNavRightButtons, //Hybrid头部多按钮定制协议
    appSetTitle, //刷新标题
    //登陆API
    appLogin, //调用登录界面
    appLogout, //登出当前帐号
    //获取信息
    getLoginResult, //获取登陆信息
    getAppVersion,// 获取本地应用版本信息
    getSysDeviceInfo,// 客户端信息 kkaction
    getSysData, //sys(获取设备信息)
    //调出模块API
    openShare,// 分享 
    openAlbum,// 打开相册 
    openCamera,// 打开相机
    //跳转API
    openAppTopic,// Native-打开漫画专题
    openAppComic,// Native-漫画章节页
    openWebview,// 新开webview页面
    openNavAction,//客户端通用跳转 
} = kkmhSDk;
export {
    kkmhSDk, // 所有方法集合
    getAppUA,//获取当前用户的运行环境
    //通知
    appOnShow,//设置显示页面
    appRecivefreecardinfo,//设置接收网卡信息
    appViewStatus,//通知webview显示与否
    //控制webView
    appClosePage,//关闭页面
    appHeader,//顶部、底部栏隐藏和显示 
    appSetNavRightButtons, //Hybrid头部多按钮定制协议
    appSetTitle, //刷新标题
    //登陆API
    appLogin, //调用登录界面
    appLogout, //登出当前帐号
    //获取信息
    getLoginResult, //获取登陆信息
    getAppVersion,// 获取本地应用版本信息
    getSysDeviceInfo,// 客户端信息 kkaction
    getSysData, //sys(获取设备信息)
    //调出模块API
    openShare,// 分享 
    openAlbum,// 打开相册 
    openCamera,// 打开相机
    //跳转API
    openAppTopic,// Native-打开漫画专题
    openAppComic,// Native-漫画章节页
    openWebview,// 新开webview页面
    openNavAction//客户端通用跳转 
};






// WEBPACK FOOTER //
// ./src/assets/js/SDK_copy/kkmh.sdk.js